import React, { ComponentProps, FunctionComponent } from "react";

const MailIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M11 4.5V2C11 1.44772 10.5523 1 10 1H2C1.44772 1 1 1.44772 1 2V8.5C1 9.05228 1.44772 9.5 2 9.5H13M1.5 1.5L5.29289 5.29289C5.68342 5.68342 6.31658 5.68342 6.70711 5.29289L10.5 1.5M13 9.5L9.5 6M13 9.5L9.5 13",
      stroke: "currentColor",
      strokeWidth: "1.2",
    })
  );
};

const ForwardRef = React.forwardRef(MailIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
